module.exports = __webpack_public_path__ + "img/50exp.eee0d319.jpg";